<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">账号信息</div>
    </div>
    <div class="inventory-box">
      <ul class="inventory-list">
        <li class="clearfix" v-for="(inventory, index) in lists" :key="index">
          <h1>{{ inventory.name }}</h1>
          <span
            >选书权限 &nbsp;({{
              statusText[inventory.bookSelectionAuthority]
            }})</span
          >
          <span class="time" @click="updatepassword">修改密码</span>
        </li>
      </ul>
    </div>
    <el-dialog
      :visible.sync="phonedialogVisible"
      width="550px"
      :before-close="handleClose"
    >
      <div class="login">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm loginFrom"
        >
          <el-form-item label="旧密码:" prop="oldpwd">
            <el-input
              show-password
              v-model.trim="ruleForm.oldpwd"
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="password">
            <el-input
              show-password
              v-model.trim="ruleForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="passwordNew">
            <el-input
              show-password
              v-model.trim="ruleForm.passwordNew"
              placeholder="请输入确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="buttondiv">
          <div class="loginBut commonstylepass" @click="phoneInfo('ruleForm')">
            确定
          </div>
          <div class="cancle commonstylepass" @click="cancle('ruleForm')">
            取消
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getInfo } from '../../api/index'
import { updatePwd } from '../../api/wapi'
import md5 from 'js-md5'
export default {
  data() {
    return {
      phonedialogVisible: false,
      lists: [],
      statusText: {
        1: '已开启',
        2: '未开启',
      },
      ruleForm: {
        oldpwd: '',
        password: '',
        passwordNew: '',
      },
      rules: {
        oldpwd: [{ required: true, trigger: 'blur', message: '请输入旧密码' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        passwordNew: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.getPersonData()
  },
  methods: {
    handleClose() {
      this.phonedialogVisible = false
    },
    async getPersonData() {
      var res = await getInfo()
      this.lists = res && res.data ? [res.data] : [{}]
    },
    phoneInfo() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.ruleForm.password != this.ruleForm.passwordNew) {
            this.$message.error('两次输入密码不一致')
          } else if (this.ruleForm.oldpwd == this.ruleForm.password) {
            this.$message.error('新密码不能与就密码相同')
          } else {
            var par = {
              oldPassword: md5(md5(this.ruleForm.oldpwd)),
              newPassword: md5(md5(this.ruleForm.password)),
            }
            updatePwd(par)
              .then((result) => {
                console.log(result)
                window.localStorage.clear()
                this.$router.push('/')
                this.$router.go(0)
              })
              .catch((err) => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.phonedialogVisible = false
    },
    updatepassword() {
      this.phonedialogVisible = true
    },
    cancle() {
      this.phonedialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.login {
  margin: 0 70px 0px;
  width: 365px;
  .buttondiv {
    height: 100px;
  }
  .line {
    width: 360px;
    height: 1px;
    background: rgba(238, 238, 238, 1);
    margin: 70px 0 30px;
  }
}
.loginFrom .el-form-item__error {
  margin-left: 85px;
}
.loginBut {
  background: #0082F0;
}
.commonstylepass {
  height: 42px;
  font-size: 16px;
  color: rgba(255, 255, 255, 1);
  line-height: 42px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 30px;
  width: 160px;
  float: left;
  cursor: pointer;
}
.cancle {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #000;
  margin-left: 20px;
}
.maincen {
  margin: 0 0px !important;
  min-height: 712px;
  padding-left: 40px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 8px;
    height: 18px;
    background: #0082F0;
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
<style lang="scss" scoped>
.inventory-box {
  border: 1px solid #e6e6e6;
  width: 100%;
  margin-top: 20px;
  .inventory-list {
    padding: 0px 30px 40px 30px;
  }
}
.inventory-list li {
  font-family: Microsoft YaHei;
  border-bottom: 1px dashed #e6e6e6;
  margin-top: 20px;
}

.inventory-list li h1 {
  width: 300px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 14px;
  margin-bottom: 20px;
  float: left;
  overflow: hidden;
}
.inventory-list li span {
  float: left;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  margin-left: 50px;
}
.inventory-list li span.reviewe-delay {
  color: #ff9a2b;
}
.inventory-list li span.reviewe-finish {
  color: #24c31c;
}
.inventory-list li span.reviewe-rough {
  color: #999999;
}
.inventory-list li span.reviewe-lose {
  color: #0082F0;
}
.inventory-list li span.time a {
  text-decoration: none;
  outline: none;
}
.inventory-list li span.time {
  float: right;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  cursor: pointer;
  line-height: 14px;
}
.inventory-list li span.time i {
  font-style: normal;
}
</style>
